import angular from 'angular';
import { ApuracoesPontoService } from '../apuracoesponto.service';
import { IApuracaoPonto } from '../../models/apuracaoponto.model';

export class ApuracoesPontoIndexController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        '$stateParams',
        '$http',
        'ApuracoesPontoService',
        'NewToaster'
    ];

    // initial state
    public entities: Array<IApuracaoPonto> = [];
    public busy: boolean = false;

    constructor (
        public $rootScope: angular.IRootScopeService & {
            liberadoTela: (arg: string) => boolean,
			temPermissao: (arg: string) => boolean,
			session: any,
            nsjGlobals: any
		},
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public $stateParams: angular.ui.IStateParamsService,
        public $http: angular.IHttpService,
        public ApuracoesPontoService: ApuracoesPontoService,
        public NewToaster: { pop: Function }
    ) {
        this.busy = true;
        this.carregaApuracoes();

        $scope.$on('apuracoesponto_index_loaded', () => {
            this.busy = false;
        });

        $scope.$on('apuracoesponto_index_error', () => {
            this.busy = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Não foi possível carregar as apurações de ponto.',
            });
        });
    }

    refresh() {
        if (this.busy || this.ApuracoesPontoService.loadParams.busy) {
            return;
        }

        this.$scope.$broadcast('apuracoesponto_index_manual_refresh_started');
        this.carregaApuracoes(3);
    }

	carregaApuracoes(pagesToLoad: number = 3) {
        this.busy = true;
		this.ApuracoesPontoService.constructors['vigente'] = false;
		this.ApuracoesPontoService.constructors['empresa'] = this.$rootScope.session.entities.empresa.empresa;
		this.ApuracoesPontoService.constructors['estabelecimento'] = '';
		this.entities = this.ApuracoesPontoService.reload(pagesToLoad);
	}
}
